<template>
  <sp-button variant="text-inline" size="small">
    <sp-icon slot="prepend" name="wysiwyg-sparkle-ai-color"></sp-icon>
    {{ text }}
  </sp-button>
</template>

<script setup>
defineProps({
  text: {
    type: String,
    default: undefined,
  },
});
</script>

<style scoped>
sp-icon {
  --size: 24px;
  display: inline-block;
}

sp-button {
  --sp-comp-button-font-weight: normal;
  --hover-bg-opacity: 0;
  --hover-text-color: var(--sp-sys-color-link-hover);
  --text-color: var(--sp-sys-color-link);
}

sp-button::part(content) {
  display: var(--sp-comp-ai-generator-quill-app-activator-button-content-display, inline-block);
}
</style>
